import styled from 'styled-components';

export const Content = styled.div``;

export const Item = styled.div`
  margin-bottom: 20px;
  &:last-child{
    margin-bottom: 0;
  }
`;

export const ItemTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  height: 28px;
  color: #e6eaec;
  margin-bottom: 8px;
  img {
    margin-right: 12px;
    border-radius: 7px;
  }
`;

export const ItemContent = styled.div`
  color: #aab2b8;
  font-size: 12.5px;
  line-height: 1.4;
  padding-left: 40px;
`;
